import { isDefined } from "@clipboard-health/util-ts";

interface VisitInviteMessageData {
  visitId: string | undefined;
}

/**
 * Check if a string is valid JSON
 */
function isValidJson(value: string): boolean {
  try {
    JSON.parse(value);
    return true;
  } catch {
    return false;
  }
}

/**
 * Parse visit invite data from the admin message data field.
 * Returns visitId if present and valid.
 */
export function parseVisitInviteMessageData(data: string | undefined): VisitInviteMessageData {
  const defaultData: VisitInviteMessageData = {
    visitId: undefined,
  };

  if (!isDefined(data) || data === "") {
    return defaultData;
  }

  if (!isValidJson(data)) {
    return defaultData;
  }

  try {
    const parsed = JSON.parse(data) as { visitId?: string };

    if (typeof parsed.visitId === "string") {
      return { visitId: parsed.visitId };
    }

    return defaultData;
  } catch {
    // Silently return default data for parse failures
    return defaultData;
  }
}
